import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { AlignmentsLayer } from '@openlayers/alignments/AlignmentsLayer';
import { setMapCursor } from '@openlayers/ol-utils';
import Feature from 'ol/Feature';
import { mapRootStore } from '@pages/map/map';
import { runInAction } from 'mobx';


export class AlignmentDesktopMouseInteraction extends FeatureMouseInteraction<AlignmentsLayer> {

    onClick = (feature: Feature, e, n): void => {
        runInAction(() => {
            mapRootStore.setActiveAlignment(feature.get('data').modelId, feature.get('data').index || 0);
        });
    };

    onMouseOver = (feature: Feature, e, n): void => {
        setMapCursor(this.map, 'crosshair');
    };
}
